import { render } from "./TheDetailPageHeader.vue?vue&type=template&id=18ffd4ad&scoped=true&ts=true"
import script from "./TheDetailPageHeader.vue?vue&type=script&lang=ts"
export * from "./TheDetailPageHeader.vue?vue&type=script&lang=ts"

import "./TheDetailPageHeader.vue?vue&type=style&index=0&id=18ffd4ad&lang=scss&scoped=true"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ffd4ad"]])

export default __exports__